import UrlFactory from '../../data/url_factory';
import { getAuthCookie } from '../../utils/cookies';
import { companyHeaders, isFeatureEnabled, onCompanyReset } from '../../company/session';
import { FEATURES } from '../../company/features';

// Inventory codes are captured from a product's `value`, but case/whitespace drift over time
// (e.g. "charmy-07-0124" stored in inventory vs "CHARMY-07-0124" in the catalog). Normalize
// before comparing — this mirrors the mobile app, which matches inventory codes lowercased.
export function normalizeProductCode(code) {
    return String(code ?? '').trim().toLowerCase();
}

// Resolve a catalog product from an inventory productId / code, tolerant of case & whitespace.
export function findProductByValue(code) {
    const target = normalizeProductCode(code);
    if (!target) return null;
    return productList.find((p) => normalizeProductCode(p?.value) === target) || null;
}

export const productList = [
    {
        name: 'Arroz Dorado 800g',
        value: 'DORADO-0130',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_dorado_800.png'
    },
    {
        name: 'Arroz Esmeralda 900g',
        value: 'ESMERALDA-0924',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_esmeralda_900.png'
    },
    {
        name: 'Arroz Integral 800g',
        value: 'INTEGRAL-0130',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_integral_800.png'
    },
    {
        name: 'Arroz Premium 900g',
        value: 'PREMIUM-0924',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_premium_900.png'
    },
    {
        name: 'Arroz Premium 2kg',
        value: 'PREMIUM-0212',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_premium_900.png'
    },
    {
        name: 'Arroz Superior 900g',
        value: 'BLANCO-0324',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_superior_1000.png'
    },
    {
        name: 'Arroz Superior 1000g',
        value: 'BLANCO-0124',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_superior_1000.png'
    },
    {
        name: 'Arroz Tradicional 900g',
        value: 'TRADICIONAL-0324',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_tradicional_1000.png'
    },
    {
        name: 'Arroz Tradicional 1000g',
        value: 'TRADICIONAL-0124',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_tradicional_1000.png'
    },
    {
        name: 'Arroz Emi',
        value: 'EMI-2401',
        category: 'arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/arroz/arroz_emi.png'
    },
    {
        name: 'Charmy Brownie 192g',
        value: 'CHARMY-10-0124',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_brownie_192.jpg'
    },
    {
        name: 'Charmy ChocoMania 192g',
        value: 'CHARMY-11-0124',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_chocomania_192.jpg'
    },
    {
        name: 'Charmy Bombón 192g',
        value: 'CHARMY-12-0124',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy-bombon-192.png'
    },

    {
        name: 'Charmy Chocolate 192g',
        value: 'CHARMY-07-0424',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_chocolate_192.png'
    },
    {
        name: 'Charmy Fresa 192g',
        value: 'CHARMY-07-0524',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_fresa_192.png'
    },
    {
        name: 'Charmy Moka 192g',
        value: 'CHARMY-06-0224',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_moka_192.png'
    },
    {
        name: 'Charmy Naranja 192g',
        value: 'CHARMY 08-0124',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_naranja_192.png'
    },
    {
        name: 'Charmy Vainilla 192g',
        value: 'CHARMY-07-0124',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_vainilla_192.png'
    },
    {
        name: 'TipTop Choco 96g',
        value: 'TIPTOP-06-0248',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/tiptop_choco_96.png'
    },
    {
        name: 'TipTop ChocoCoco 96g',
        value: 'TIPTOP-06-0148',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/tiptop_chocococo_96.png'
    },
    {
        name: 'TipTop ChocoMani 96g',
        value: 'TIPTOP-06-0348',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/tiptop_chocomani_96.png'
    },
    {
        name: 'TipTop Coco 96g',
        value: 'TIPTOP-06-0448',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/tiptop_coco_96.png'
    },
    {
        name: 'TipTop Limon 96g',
        value: 'TIPTOP-06-0548',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/tiptop_limon_96.png'
    },
    {
        name: 'TipTop Mani 96g',
        value: 'TIPTOP-06-0648',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/tiptop_mani_96.png'
    },
    {
        name: 'TipTop Vainilla 96g',
        value: 'TIPTOP-06-0748',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/tiptop_vainilla_96.png'
    },
    {
        name: 'Estuche TipTop Vainilla',
        value: 'TIPTOP-05-0708',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/estuche_tiptop_vainilla.png'
    },
    {
        name: 'Estuche TipTop Chocolate',
        value: 'TIPTOP-05-0208',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/estuche_tiptop_chocolate.png'
    },
    {
        name: 'Crema de Arroz 450g',
        value: 'CREMA-0324',
        category: 'crema_de_arroz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/crema_de_arroz/crema_arroz_450.png'
    },
    {
        name: 'Arvejas Amarillas 400g',
        value: 'ARVEJAS-A-30X400',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/arvejas_amarillas_400.png'
    },
    {
        name: 'Arvejas Verdes 400g',
        value: 'ARVEJAS-V-30X400',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/arvejas_verdes_400.png'
    },
    {
        name: 'Caraotas Blancas 500g',
        value: 'CARAOTAS-0324',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/caraotas_blancas_500.png'
    },
    {
        name: 'Caraotas Negras 400g',
        value: 'CARAOTAS-30X400',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/caraotas_negras_400.png'
    },
    {
        name: 'Caraotas Negras 500g',
        value: 'CARAOTAS-0124',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/caraotas_negras_500.png'
    },
    {
        name: 'Caraotas Rojas 500g',
        value: 'CARAOTAS-0224',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/caraotas_rojas_500.png'
    },
    {
        name: 'Garbanzos 500g',
        value: 'GARBANZO-0124',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/garbanzos_500.png'
    },
    {
        name: 'Lentejas 400g',
        value: 'LENTEJAS-30X400',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/lentejas_400.png'
    },
    {
        name: 'Maiz de Cotufas 400g',
        value: 'MAIZ-0130',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/maiz_cotufas_500.png'
    },
    {
        name: 'Maiz de Cotufas 500g',
        value: 'MAIZ-0124',
        category: 'granos',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/granos/maiz_cotufas_500.png'
    },
    {
        name: 'Harina de Maiz 900g',
        value: 'HDMB-20900',
        category: 'harina_de_maiz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/harina_de_maiz/harina-de-maiz-mary.png'
    },
    {
        name: 'Harina de Maiz 2Kg',
        value: 'HDMB-22000',
        category: 'harina_de_maiz',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/harina_de_maiz/harina-de-maiz-mary.png'
    },
    {
        name: 'Harina de Trigo Leudante',
        value: 'HTMLE-2001',
        category: 'harina_de_trigo_leudante',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/harina_de_trigo/harina_de_trigo_leudante.png'
    },
    {
        name: 'Harina de Trigo Todo Uso',
        value: 'HTTUE-2090',
        category: 'harina_de_trigo_todo_uso',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/harina_de_trigo/harina_de_trigo_todo_uso.png'
    },
    {
        name: 'Harina Panadera Saco',
        value: 'HTP-0345',
        category: 'harina_de_trigo',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/harina_de_trigo/harina_panadera_saco.png'
    },
    {
        name: 'Maria Caledonia 150g',
        value: 'MARIA-24150',
        category: 'maria_caledonia',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/maria_caledonia/maria_caledonia_168.png'
    },
    {
        name: 'Maria Caledonia 168g',
        value: 'MARIA-2416',
        category: 'maria_caledonia',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/maria_caledonia/maria_caledonia_168.png'
    },
    {
        name: 'Maria Caledonia 252g',
        value: 'MARIA-2425',
        category: 'maria_caledonia',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/maria_caledonia/maria_caledonia_252.png'
    },
    {
        name: 'Maria Caledonia Cacao 150g',
        value: 'MARIA-2418',
        category: 'maria_caledonia',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/maria_caledonia/maria_caledonia_cacao_150.png'
    },
    {
        name: 'Aceite de Oliva 500ml',
        value: 'ACEITE-02-0212',
        category: 'aceite_de_oliva',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/aceite_de_oliva/aceite_de_oliva_500.png'
    },
    {
        name: 'Aceite de Oliva 750ml',
        value: 'ACEITE-02-0312',
        category: 'aceite_de_oliva',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/aceite_de_oliva/aceite_de_oliva_750.png'
    },
    {
        name: 'Mani Garrapiñada 80g',
        value: 'MANI-GRP-18080',
        category: 'mani',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/mani/mani_garrapinada_80.png'
    },
    {
        name: 'Mani Salado sin Piel 120g',
        value: 'MANI-SSP-2412',
        category: 'mani',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/mani/mani_salado_sin_piel_120.png'
    },
    {
        name: 'Mani Tostado sin Sal 120g',
        value: 'MANI-TSS-24120',
        category: 'mani',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/mani/mani_tostado_sin_sal_120.png'
    },
    {
        name: 'Pasta de Mani 485g',
        value: 'PASTADEMANI-1248',
        category: 'mani',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/mani/pasta_de_mani_485.png'
    },
    {
        name: 'Palmitos Enteros 400g',
        value: 'PALMITOS-0124',
        category: 'palmito',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/palmito/palmitos_enteros_400.png'
    },
    {
        name: 'Passata de Tomate 700g',
        value: 'PASSATA-0112',
        category: 'passata',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/passata/passata_700.png'
    },
    {
        name: 'Tomate Pelado 400g',
        value: 'PELADO-0324',
        category: 'tomate_pelado',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/tomate_pelado/tomate_pelado_400.png'
    },
    {
        name: 'Tomate Pelado 800g',
        value: 'PELADO-0212',
        category: 'tomate_pelado',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/tomate_pelado/tomate_pelado_800.png'
    },
    {
        name: 'Tomate Pelado 2550g',
        value: 'PELADO-0106',
        category: 'tomate_pelado',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/tomate_pelado/tomate_pelado_2550.png'
    },
    {
        name: 'Pasta Premium Dedal 500g',
        value: 'PASTA-01-0412',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_premium_dedal_500.png'
    },
    {
        name: 'Pasta Premium Linguini 500g',
        value: 'PASTA-01-0424',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_premium_linguini_500.png'
    },
    {
        name: 'Pasta Premium Macarron 500g',
        value: 'PASTA-01-0512',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_premium_macarron_500.png'
    },
    {
        name: 'Pasta Premium Pluma 500g',
        value: 'PASTA-01-0312',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_premium_pluma_500.png'
    },
    {
        name: 'Pasta Premium Rigatoni 500g',
        value: 'PASTA-01-0612',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_premium_rigatoni_500.png'
    },
    {
        name: 'Pasta Premium Tornillo 500g',
        value: 'PASTA-01-0212',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_premium_tornillo_500.png'
    },
    {
        name: 'Pasta Premium Vermicelli 500g',
        value: 'PASTA-01-0124',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_premium_vermicelli_500.png'
    },
    {
        name: 'Pasta Superior Pluma 500g',
        value: 'PASTA-08-0312',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_superior_pluma_500.png'
    },
    {
        name: 'Pasta Superior Pluma 1000g',
        value: 'PASTA-06-0212',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_superior_pluma_1000.png'
    },
    {
        name: 'Pasta Superior Spaghetti 1000g',
        value: 'PASTA-06-0412',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_superior_spaghetti_1000.png'
    },
    {
        name: 'Pasta Superior Tornillo 500g',
        value: 'PASTA-08-0212',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_superior_tornillo_500.png'
    },
    {
        name: 'Pasta Superior Tornillo 1000g',
        value: 'PASTA-06-0312',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_superior_tornillo_1000.png'
    },
    {
        name: 'Pasta Superior Vermicelli 500g',
        value: 'PASTA-08-0112',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_superior_vermicelli_500.png'
    },
    {
        name: 'Pasta Superior Vermicelli 1000g',
        value: 'PASTA-06-0112',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_superior_vermicelli_1000.png'
    },
    {
        name: 'Pasta Tradicional Dedal 500g',
        value: 'PASTA-07-0112',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_tradicional_dedal_500.png'
    },
    {
        name: 'Pasta Tradicional Pluma 500g',
        value: 'PASTA-07-0412',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_tradicional_pluma_500.png'
    },
    {
        name: 'Pasta Tradicional Pluma 1000g',
        value: 'PASTA-05-1201',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_tradicional_pluma_1000.png'
    },
    {
        name: 'Pasta Tradicional Spaghetti 1000g',
        value: 'PASTA-05-1203',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_tradicional_spaghetti_1000.png'
    },
    {
        name: 'Pasta Tradicional Vermicelli 500g',
        value: 'PASTA-07-0212',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_tradicional_vermicelli_500.png'
    },
    {
        name: 'Pasta Tradicional Vermicelli 1000g',
        value: 'PASTA-05-1202',
        category: 'pasta',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/pasta/pasta_tradicional_vermicelli_1000.png'
    },
    {
        name: 'Charmy Chocolate 16g',
        value: 'CHARMY-10-0308',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_chocolate_16.png'
    },
    {
        name: 'Charmy Fresa 16g',
        value: 'CHARMY-10-0108',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_fresa_16.png'
    },
    {
        name: 'Charmy Moka 16g',
        value: 'CHARMY-10-0408',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_moka_16.png'
    },
    {
        name: 'Charmy Vainilla 16g',
        value: 'CHARMY-10-0209',
        category: 'galleta_rellena',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/galleta_rellena/charmy_vainilla_16.png'
    },
    {
        name: 'Passata de Tomate 500g',
        value: 'PASSATA-1250',
        category: 'passata',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/passata/passata_500.png'
    },
    {
        name: 'Maria Caledonia Canela 150g',
        value: 'MARIA-2419',
        category: 'maria_caledonia',
        images: 'https://alimentos-mary.s3.amazonaws.com/productos/maria_caledonia/maria_caledonia_canela_150.png'
    }
];

export const categoryList = [
    {
        name: 'arroz',
        value: 'Arroz'
    },
    {
        name: 'pasta',
        value: 'Pasta'
    },
    {
        name: 'aceite_de_oliva',
        value: 'Aceite de Oliva'
    },
    {
        name: 'crema_de_arroz',
        value: 'Crema de Arroz'
    },
    {
        name: 'galleta_rellena',
        value: 'Galleta Rellena'
    },
    {
        name: 'granos',
        value: 'Granos'
    },
    {
        name: 'harina_de_maiz',
        value: 'Harina de Maiz'
    },
    {
        name: 'harina_de_trigo_leudante',
        value: 'Harina de Trigo Leudante'
    },
    {
        name: 'harina_de_trigo_todo_uso',
        value: 'Harina de Trigo Todo Uso'
    },
    {
        name: 'mani',
        value: 'Mani'
    },
    {
        name: 'maria_caledonia',
        value: 'Maria Caledonia'
    },
    {
        name: 'palmito',
        value: 'Palmito'
    },
    {
        name: 'passata',
        value: 'Passata'
    },
    {
        name: 'tomate_pelado',
        value: 'Tomate Pelado'
    }
];

export const categorySegments = [
    {
        category: 'aceite_comestible',
        name: 'Aceite Comestible',
        segments: [
            {
                value: 'aceite_de_girasol_1l',
                name: 'Aceite de Girasol 1L'
            },
            {
                value: 'aceite_de_girasol_500',
                name: 'Aceite de Girasol 500ml'
            },
            {
                value: 'aceite_de_maiz_1l',
                name: 'Aceite de Maiz 1L'
            },
            {
                value: 'aceite_de_soya_1l',
                name: 'Aceite de Soya 1L'
            },
            {
                value: 'aceite_de_soya_250ml',
                name: 'Aceite de Soya 250ml'
            },
            {
                value: 'aceite_de_soya_500ml',
                name: 'Aceite de Soya 500ml'
            },
            {
                value: 'aceite_vegetal_1l',
                name: 'Aceite Vegetal 1L'
            },
            {
                value: 'aceite_vegetal_500',
                name: 'Aceite Vegetal 500ml'
            },
            {
                value: 'aceite_vegetal_250',
                name: 'Aceite Vegetal 250ml'
            }
        ]
    },
    {
        category: 'aceite_de_oliva',
        name: 'Aceite de Oliva',
        segments: [
            {
                value: 'aceite_de_oliva',
                name: 'Aceite de Oliva'
            }
        ]
    },
    {
        category: 'arroz',
        name: 'Arroz',
        segments: [
            {
                value: 'arroz_especializado',
                name: 'Arroz Especializado'
            },
            {
                value: 'arroz_tipo_i_ii',
                name: 'Arroz Tipo I y II'
            }
        ]
    },
    {
        category: 'granos',
        name: 'Granos',
        segments: [
            {
                value: 'arvejas_amarrillas',
                name: 'Arvejas Amarillas'
            },
            {
                value: 'arvejas_verdes',
                name: 'Arvejas Verdes'
            },
            {
                value: 'caraotas_blancas',
                name: 'Caraotas Blancas'
            },
            {
                value: 'caraotas_negras',
                name: 'Caraotas Negras'
            },
            {
                value: 'caraotas_rojas',
                name: 'Caraotas Rojas'
            },
            {
                value: 'garbanzos',
                name: 'Garbanzos'
            },
            {
                value: 'lentejas',
                name: 'Lentejas'
            },
            {
                value: 'maiz_cotufas',
                name: 'Maiz para Cotufas'
            }
        ]
    },
    {
        category: 'azucar',
        name: 'Azucar',
        segments: [
            {
                value: 'azucar',
                name: 'Azucar'
            }
        ]
    },
    {
        category: 'cafe',
        name: 'Cafe',
        segments: [
            {
                value: 'cafe_1k',
                name: 'Cafe 1k'
            },
            {
                value: 'cafe_250g',
                name: 'Cafe 250g'
            },
            {
                value: 'cafe_500g',
                name: 'Cafe 500g'
            }
        ]
    },
    {
        category: 'crema_de_arroz',
        name: 'Crema de Arroz',
        segments: [
            {
                value: 'crema_de_arroz',
                name: 'Crema de Arroz'
            }
        ]
    },
    {
        category: 'galletas',
        name: 'Galletas',
        segments: [
            {
                value: 'galletas_maria',
                name: 'Galletas Maria'
            },
            {
                value: 'galletas_recubiertas',
                name: 'Galletas Recubiertas'
            },
            {
                value: 'galletas_rellenas',
                name: 'Galletas Rellenas'
            },
            {
                value: 'galletas_saladas',
                name: 'Galletas Saladas'
            },
            {
                value: 'galletas_wafer',
                name: 'Galletas Wafer'
            }
        ]
    },
    {
        category: 'mani',
        name: 'Mani',
        segments: [
            {
                value: 'garrapinado',
                name: 'Garrapiñado'
            },
            {
                value: 'japones',
                name: 'Japones'
            },
            {
                value: 'salado_sin_piel',
                name: 'Salado sin Piel'
            }
        ]
    },
    {
        category: 'vegetales_enlatados',
        name: 'Vegetales Enlatados',
        segments: [
            {
                value: 'guisantes_zanhahoria_enlatados',
                name: 'Guisantes con Zanahoria'
            },
            {
                value: 'guisantes',
                name: 'Guisantes'
            },
            {
                value: 'maiz',
                name: 'Maiz'
            },
            {
                value: 'maiz_guisantes',
                name: 'Maiz y Guisantes'
            },
            {
                value: 'vegetales_mixtos',
                name: 'Vegetales Mixtos'
            }
        ]
    },
    {
        category: 'harina_de_arroz',
        name: 'Harina de Arroz',
        segments: [
            {
                value: 'harina_de_arroz',
                name: 'Harina de Arroz'
            }
        ]
    },
    {
        category: 'harina_de_maiz',
        name: 'Harina de Maiz',
        segments: [
            {
                value: 'harina_de_maiz',
                name: 'Harina de Maiz'
            }
        ]
    },
    {
        category: 'harina_de_trigo_familiar',
        name: 'Harina de Trigo Familiar',
        segments: [
            {
                value: 'harina_de_trigo_leudante',
                name: 'Harina de Trigo Leudante'
            },
            {
                value: 'harina_de_trigo_todo_uso',
                name: 'Harina de Trigo Todo Uso'
            }
        ]
    },
    {
        category: 'harina_de_trigo_panadera',
        name: 'Harina de Trigo Panadera',
        segments: [
            {
                value: 'harina_de_trigo_panadera',
                name: 'Harina de Trigo Panadera'
            }
        ]
    },
    {
        category: 'leche',
        name: 'Leche',
        segments: [
            {
                value: 'leche_en_polvo_1k',
                name: 'Leche en Polvo 1k'
            },
            {
                value: 'leche_en_polvo_250g',
                name: 'Leche en Polvo 250g'
            },
            {
                value: 'leche_en_polvo_500g',
                name: 'Leche en Polvo 500g'
            },
            {
                value: 'leche_liquida_1l',
                name: 'Leche Liquida 1L'
            },
            {
                value: 'leche_liquida_500ml',
                name: 'Leche Liquida 500mL'
            },
            {
                value: 'leche_liquida_250ml',
                name: 'Leche Liquida 250mL'
            }
        ]
    },
    {
        category: 'margarina',
        name: 'Margarina',
        segments: [
            {
                value: 'manteca',
                name: 'Manteca'
            },
            {
                value: 'mantequilla',
                name: 'Mantequilla'
            },
            {
                value: 'margarina',
                name: 'Margarina'
            }
        ]
    },
    {
        category: 'mayoenesa',
        name: 'Mayonesa',
        segments: [
            {
                value: 'mayonesa',
                name: 'Mayonesa'
            }
        ]
    },
    {
        category: 'palmitos',
        name: 'Palmitos',
        segments: [
            {
                value: 'palmitos',
                name: 'palmitos'
            }
        ]
    },
    {
        category: 'passata',
        name: 'Passata',
        segments: [
            {
                value: 'passata',
                name: 'Passata'
            }
        ]
    },
    {
        category: 'pasta',
        name: 'Pasta',
        segments: [
            {
                value: 'pasta_1k',
                name: 'Pasta 1k'
            },
            {
                value: 'pasta_500g',
                name: 'Pasta 500g'
            },
            {
                value: 'pasta_pasticho',
                name: 'Pasta para Pasticho'
            },
            {
                value: 'pastina',
                name: 'Pastina'
            }
        ]
    },
    {
        category: 'salsas',
        name: 'Salsas',
        segments: [
            {
                value: 'pasta_tomate_250g',
                name: 'Pasta de Tomate 250g'
            },
            {
                value: 'pasta_tomate_500g',
                name: 'Pasta de Tomate 500g'
            },
            {
                value: 'salsa_tomate_250g',
                name: 'Salsa de Tomate 250g'
            },
            {
                value: 'salsa_tomate_500g',
                name: 'Salsa de Tomate 500g'
            },
            {
                value: 'salsa_pizza_250g',
                name: 'Salsa para Pizza 250g'
            },
            {
                value: 'salsa_pizza_500g',
                name: 'Salsa para Pizza 500g'
            },
            {
                value: 'salsas_listas_250g',
                name: 'Salsas Listas 250g'
            },
            {
                value: 'salsas_listas_500g',
                name: 'Salsas Listas 500g'
            }
        ]
    },
    {
        category: 'tomate_pelado',
        name: 'Tomate Pelado',
        segments: [
            {
                value: 'tomate_pelado',
                name: 'Tomate Pelado'
            }
        ]
    },
    {
        category: 'vinagre',
        name: 'Vinagre',
        segments: [
            {
                value: 'vinagre_1000ml',
                name: 'Vinagre 1000ml'
            },
            {
                value: 'vinagre_500ml',
                name: 'Vinagre 500ml'
            }
        ]
    }
];

const PRODUCT_CACHE_KEY = 'admin_product_catalog_cache_v1';
const CATEGORY_CACHE_KEY = 'admin_category_catalog_cache_v1';
let syncCatalogPromise = null;
// When the catalog last came from the API: every page mounts a controller that syncs it, so
// without this each navigation re-downloaded every product and category.
let lastRemoteSyncAt = 0;
const CATALOG_FRESH_MS = 5 * 60 * 1000;

function replaceArrayContents(target, items) {
    target.splice(0, target.length, ...(Array.isArray(items) ? items : []));
}

/** Empty the in-memory catalog (bundled seed and anything synced). */
function clearCatalog() {
    replaceArrayContents(productList, []);
    replaceArrayContents(categoryList, []);
    replaceArrayContents(categorySegments, []);
    syncCatalogPromise = null;
    lastRemoteSyncAt = 0;
}

// The catalog above is the one bundled with this admin (Mary's). A company without it starts
// from an empty catalog until its own API answers, and a company reset forgets it.
if (!isFeatureEnabled(FEATURES.BUNDLED_CATALOG)) clearCatalog();
onCompanyReset(clearCatalog);

function normalizeProduct(raw) {
    if (!raw) return null;
    const value = raw.value || raw.productId || raw.product_id || raw.code || '';
    const name = raw.name || raw.productName || raw.product_name || '';
    const category = raw.category || raw.category_name || 'sin_categoria';
    const imageUri = typeof raw.images === 'string' ? raw.images : raw?.images?.uri || '';
    if (!value || !name) return null;
    return { name, value, category, images: imageUri };
}

function titleFromCategory(category) {
    return String(category || '')
        .split('_')
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}

function normalizeCategories(rawCategories = [], products = []) {
    if (Array.isArray(rawCategories) && rawCategories.length > 0) {
        return rawCategories
            .map((category) => {
                if (typeof category === 'string') {
                    return { name: category, value: titleFromCategory(category) };
                }
                const name = category?.name || category?.category || category?.value;
                const value = category?.value || category?.label || titleFromCategory(name);
                return name ? { name, value } : null;
            })
            .filter(Boolean);
    }

    const unique = [...new Set(products.map((product) => product.category).filter(Boolean))];
    return unique.map((name) => ({ name, value: titleFromCategory(name) }));
}

async function fetchAllProductsFromBackend() {
    const token = getAuthCookie();
    if (!token || token === 'expired') return [];

    const urlFactory = new UrlFactory();
    const pageSize = 500;
    let page = 1;
    const products = [];

    while (page <= 100) {
        const url = `${urlFactory.apiUrl}/products?page=${page}&limit=${pageSize}&includeInactive=true`;
        const response = await fetch(url, { headers: { token, ...companyHeaders() } });
        if (!response.ok) throw new Error(`Products fetch failed with status ${response.status}`);
        const data = await response.json();
        const batch = Array.isArray(data?.products) ? data.products : [];
        products.push(...batch.map(normalizeProduct).filter(Boolean));
        if (!data?.pagination?.hasNext) break;
        page += 1;
    }

    return products;
}

async function fetchCategoriesFromBackend() {
    const token = getAuthCookie();
    if (!token || token === 'expired') return [];
    const urlFactory = new UrlFactory();
    const response = await fetch(`${urlFactory.apiUrl}/products/categories`, { headers: { token, ...companyHeaders() } });
    if (!response.ok) return [];
    const data = await response.json();
    return data?.categories || [];
}

/**
 * Load the catalog (cache first, then the API). Skips the API when it answered less than
 * 5 minutes ago, unless `force` (after a product or category change).
 */
export async function syncAdminProductCatalog({ force = false } = {}) {
    if (syncCatalogPromise) return syncCatalogPromise;
    if (!force && productList.length > 0 && Date.now() - lastRemoteSyncAt < CATALOG_FRESH_MS) {
        return { source: 'memory', count: productList.length };
    }

    syncCatalogPromise = (async () => {
        try {
            const cachedProductsRaw = localStorage.getItem(PRODUCT_CACHE_KEY);
            const cachedCategoriesRaw = localStorage.getItem(CATEGORY_CACHE_KEY);
            const cachedProducts = cachedProductsRaw ? JSON.parse(cachedProductsRaw) : [];
            const cachedCategories = cachedCategoriesRaw ? JSON.parse(cachedCategoriesRaw) : [];

            if (cachedProducts.length > 0) {
                replaceArrayContents(productList, cachedProducts);
                replaceArrayContents(categoryList, cachedCategories.length > 0 ? cachedCategories : normalizeCategories([], cachedProducts));
            } else {
                replaceArrayContents(productList, []);
                replaceArrayContents(categoryList, []);
            }

            const remoteProducts = await fetchAllProductsFromBackend();
            if (remoteProducts.length === 0) {
                // A catalog without products yet can still have categories (Mimesa manages
                // them before its first product): filters and forms offer those.
                const categoriesOnly = normalizeCategories(await fetchCategoriesFromBackend(), []);
                if (categoriesOnly.length > 0 && cachedProducts.length === 0) {
                    replaceArrayContents(categoryList, categoriesOnly);
                    localStorage.setItem(CATEGORY_CACHE_KEY, JSON.stringify(categoriesOnly));
                }
                return { source: cachedProducts.length > 0 ? 'cache' : 'empty', count: productList.length };
            }

            const remoteCategoriesRaw = await fetchCategoriesFromBackend();
            const remoteCategories = normalizeCategories(remoteCategoriesRaw, remoteProducts);

            replaceArrayContents(productList, remoteProducts);
            replaceArrayContents(categoryList, remoteCategories);

            localStorage.setItem(PRODUCT_CACHE_KEY, JSON.stringify(remoteProducts));
            localStorage.setItem(CATEGORY_CACHE_KEY, JSON.stringify(remoteCategories));
            lastRemoteSyncAt = Date.now();

            return { source: 'remote', count: remoteProducts.length };
        } catch (error) {
            console.error('Failed to sync admin product catalog:', error);
            return { source: productList.length > 0 ? 'cache' : 'empty', count: productList.length };
        } finally {
            syncCatalogPromise = null;
        }
    })();

    return syncCatalogPromise;
}
